// ElevenLabs Text-to-Speech — ultra-natural voices for event announcements
const ELEVENLABS_API = 'https://api.elevenlabs.io/v1/text-to-speech';

// Curated voice IDs — change via TTS settings
export const TTS_VOICES = {
  female: {
    id: '21m00Tcm4TlvDq8ikWAM',
    name: 'Rachel',
    description: 'Voix féminine — chaleureuse et claire'
  },
  male: {
    id: 'VR6AewLTigWG4xSOukaG',
    name: 'Arnold',
    description: 'Voix masculine — assurée et naturelle'
  }
};

const DEFAULT_VOICE_SETTINGS = {
  stability: 0.55,
  similarity_boost: 0.75,
  style: 0.0,
  use_speaker_boost: true
};

// Cache audio blobs in memory to avoid duplicate API calls
const audioCache = new Map();

function stripEmojis(text) {
  return text
    .replace(/[\u{1F300}-\u{1FFFF}]/gu, '')
    .replace(/[\u{2600}-\u{26FF}]/gu, '')
    .replace(/[\u{2700}-\u{27BF}]/gu, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

export async function speak(text, { gender = 'female', volume = 1.0 } = {}) {
  const apiKey = process.env.REACT_APP_ELEVENLABS_API_KEY;
  if (!apiKey) {
    console.warn('[TTS] REACT_APP_ELEVENLABS_API_KEY non définie — synthèse vocale désactivée');
    return;
  }

  const cleanText = stripEmojis(text);
  if (!cleanText) return;

  const voice = TTS_VOICES[gender] ?? TTS_VOICES.female;
  const cacheKey = `${voice.id}:${cleanText}`;

  let audioUrl = audioCache.get(cacheKey);

  if (!audioUrl) {
    const response = await fetch(`${ELEVENLABS_API}/${voice.id}`, {
      method: 'POST',
      headers: {
        'xi-api-key': apiKey,
        'Content-Type': 'application/json',
        'Accept': 'audio/mpeg'
      },
      body: JSON.stringify({
        text: cleanText,
        model_id: 'eleven_multilingual_v2',
        voice_settings: DEFAULT_VOICE_SETTINGS
      })
    });

    if (!response.ok) {
      console.error('[TTS] Erreur ElevenLabs', response.status, await response.text());
      return;
    }

    const blob = await response.blob();
    audioUrl = URL.createObjectURL(blob);
    audioCache.set(cacheKey, audioUrl);

    // Limit cache size to 30 entries
    if (audioCache.size > 30) {
      const firstKey = audioCache.keys().next().value;
      URL.revokeObjectURL(audioCache.get(firstKey));
      audioCache.delete(firstKey);
    }
  }

  const audio = new Audio(audioUrl);
  audio.volume = Math.min(1, Math.max(0, volume));
  return audio.play();
}
